var map = {
	"./house_aquarius_grey.png": 1917,
	"./house_aries_grey.png": 7804,
	"./house_cancer_grey.png": 3324,
	"./house_capricorn_grey.png": 4405,
	"./house_gemini_grey.png": 4195,
	"./house_leo_grey.png": 2870,
	"./house_libra_grey.png": 7752,
	"./house_pisces_grey.png": 2401,
	"./house_sagittarius_grey.png": 7104,
	"./house_scorpio_grey.png": 5131,
	"./house_taurus_grey.png": 2148,
	"./house_virgo_grey.png": 3281
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 6057;